import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const dashboardsDirectoryRoute: InvariantJiraRoute = {
	name: 'dashboards-directory',
	path: '/jira/dashboards',
};
